module.exports = __webpack_public_path__ + "img/ditu.2e52cac9.png";